export default __webpack_public_path__ + "static/b&w_białe tło-1d1f92328394a14bb0d5bf9e8787547a.jpg";